$(document).on('change', '[data-payment-method-input]', function() {
  const birthDate = $('[data-birth-date]');
  if (birthDate.length) {
    const paymentMethodInvoice = birthDate.attr('data-birth-date');
    birthDate[$(this).attr('data-payment-method') === paymentMethodInvoice ? 'removeClass' : 'addClass']('hide');
  }
});

$(document).on('mouseover', '[data-bind-prop-toggle]', (event) => {
  event.preventDefault();
  const ckbox = $('#id_accept_terms').is(':checked');
  if (!ckbox) {
    $('.checkout_terms_check').removeClass('hide');
    $('#id_accept_terms').addClass('checkout_terms_check__cbxcolor');
  }
});

$(document).on('mouseout', '[data-bind-prop-toggle]', (event) => {
  event.preventDefault();
  const ckbox = $('#id_accept_terms').is(':checked');
  if (!ckbox) {
    $('.checkout_terms_check').addClass('hide');
    $('#id_accept_terms').removeClass('checkout_terms_check__cbxcolor');
  }
});

$(document).on('forminvalid.zf.abide', '[data-checkout-update-form]', function() {
  $(this).find('.is-invalid-input:first').focus();
  $(this).closest('.widget')[0].scrollIntoView();
});

// comment counter

function limitCheckoutComment(event, value) {
  const newLines = value.split('\n').length;
  if (event.keyCode === 13 && newLines >= 1) {
    return false;
  }
  return true;
}

$(document).on('keydown', '[data-checkout-update-form] textarea#id_internal_comment', function(event) {
  const change = limitCheckoutComment(event, $(this).val());
  if (!change) {
    event.preventDefault();
  }
  return change;
});

$(document).on('keyup', '[data-checkout-update-form] textarea#id_internal_comment', function() {
  $('[data-checkout-update-form] [data-checkout-comment-counter]').text(100 - $(this).val().length);
});
